export default __webpack_public_path__ + "static/media/morning.07ceeefb.svg";